<template>
  <div class="collect">
    <el-tabs v-model="targetName">
      <el-tab-pane label="商品百科" name="product">
        <span slot="label">
          <div class="label">商品百科</div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="商品营销" name="service">
        <span slot="label">
          <div class="label">商品营销</div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="一村一品" name="ovop">
        <span slot="label">
          <div class="label">一村一品</div>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div class="line">
      <el-alert v-if="retrieve.results.length == 0" title="暂无数据" type="success" :closable="false"></el-alert>
      <div
        :class="(index + 1) % 5 ? 'item' : 'item item-last'"
        v-for="(item, index) in retrieve.results"
        :key="index"
        @click="click(item)"
      >
        <img :src="util.getImageUrl(util.getHead(util.string2Array(item.image)), '180x180')" alt />
        <div class="name">{{item.name}}</div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="retrieve.page.totalCount"
      :page-size="retrieve.page.numPerPage"
      :current-page="retrieve.page.pageNum"
      @current-change="onCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "MyCollect",
  props: ["my"],
  data() {
    return {
      targetName: "product",
      retrieve: {
        page: {
          totalCount: 0,
          pageNum: 1,
          pageCount: 0,
          numPerPage: 20
        },
        results: []
      }
    };
  },
  created() {
    this.fetch();
  },
  watch: {
    targetName: function() {
      this.fetch();
    }
  },
  methods: {
    async fetch() {
      this.retrieve = await this.ajax.doPost({
        packageName: "user",
        className: "userFavorite",
        methodName: "retrieve",
        params: {
          targetName: this.targetName,

          ...this.retrieve.page
        }
      });
    },
    click(e) {
      switch (e.type) {
        case "product":
          window.open("/product/baike/" + e.id);
          break;
        case "service":
          window.open("/service/detail/" + e.id);
          break;
        case "ovop":
          window.open("/ovop/detail/" + e.id);
          break;
      }
    },
    async onCurrentChange(e) {
      this.retrieve = await this.ajax.doPost({
        packageName: "user",
        className: "userFavorite",
        methodName: "retrieve",
        params: {
          ...this.retrieve.page,
          targetName: this.targetName,
          pageNum: e
        }
      });
    }
  }
};
</script>

<style lang="less">
.collect {
  .el-tabs__active-bar {
    height: 0;
  }

  .el-tabs__header {
    width: 40%;
    margin: 30px auto;
  }
}
</style>


<style lang="less" scoped>
.collect {
  width: 100%;
  background: white;
  padding: 1px 60px;

  .label {
    line-height: 32px;
    background: white;
    border-radius: 16px;
    font-size: 14px;
    color: #333;
    padding: 0 20px;
  }

  .is-active {
    .label {
      line-height: 32px;
      background: #1b994f;
      border-radius: 16px;
      font-size: 14px;
      color: white;
      padding: 0 20px;
    }
  }

  .line {
    .item {
      display: inline-block;

      text-align: center;

      width: 180px;

      margin-right: 20px;
      margin-bottom: 20px;

      cursor: pointer;

      background: #f7faf8;

      border-radius: 10px;

      img {
        border-radius: 10px 10px 0 0;
        width: 100%;
        height: 100%;
      }

      .name {
        margin: 5px 0;
        height: 40px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

        text-align: center;
      }

      .features {
        font-size: 12px;
        font-weight: 400;
        color: rgba(109, 114, 120, 1);
        line-height: 17px;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 34px;
      }
    }
    .item-last {
      margin-right: 0;
    }
  }

  .page {
    .prev,
    .next {
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
    }

    .num {
      border: 1px solid #ccc;
      display: inline-block;
      margin: 0 5px;
      padding: 0 5px;
      cursor: pointer;
    }
    .active {
      color: red;
    }
  }

  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>

